import * as React from 'react';
import { memo } from 'react';
import { __ } from '../../helpers/TranslationService';

interface IProps {
    description?: string;
    facts?: string;
    shipImage?: string;
}
const ShipsView = (props: IProps) => {
    const { facts, shipImage, description } = props;
    if (!shipImage && description?.length <= 0 && facts?.length <= 0) return null;
    const compName = 'ships-view';
    return (
        <section className={`${compName}`}>
            {shipImage && <img src={shipImage} className={`${compName}__img`} alt={'shipImage'} />}
            {description?.length && (
                <p
                    dangerouslySetInnerHTML={{
                        __html: description,
                    }}
                />
            )}
            {facts?.length && (
                <p
                    className={`${compName}__facts`}
                    dangerouslySetInnerHTML={{
                        __html: facts,
                    }}
                />
            )}
        </section>
    );
};
export default memo(ShipsView);
